export default {
      id: "ic_comment_stack_circle-usage",
      viewBox: "0 0 13 14",
      url: "/" + "images/icons.3.109.2.svg#ic_comment_stack_circle-usage",
      toString: function () {
        return this.url;
      }
    }